/**
 * Strips trailing fractional zeros (and a dangling decimal point) from a
 * decimal string, without touching zeros in the integer part.
 *
 *   trimDecimalZeros('0.000100') -> '0.0001'
 *   trimDecimalZeros('5.00')     -> '5'
 *   trimDecimalZeros('100')      -> '100'
 */
export function trimDecimalZeros(value: string): string {
  if (!value.includes('.')) {
    return value;
  }
  return value.replace(/0+$/, '').replace(/\.$/, '');
}
